import { Component, Input, OnInit } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { AuthService } from '@app/services';
import { ApplicantMessageTemplate } from '@models/recruiting/applicant-message-template.model';
import { ActivatedRoute } from '@angular/router';
import { FunnelMessageTemplate } from '@models/recruiting/funnel-message-template.model';
import { FunnelTemplateStage } from '@models/recruiting/funnel-template-stages.model';
import { FunnelTemplate } from '@models/recruiting/funnel-template.model';

@Component({
    selector: 'app-funnel-message-template-form',
    templateUrl: './funnel-message-template.form.html',
})
export class FunnelMessageTemplateForm extends BaseForm implements OnInit {
    @Input() funnelMessageTemplate: FunnelMessageTemplate;
    @Input() funnelTemplateStage: FunnelTemplateStage;

    funnelTemplate: FunnelTemplate;

    templateId: number | string = 'free-form';
    previousTemplateId: number | string;
    applicantMessageTemplates: ApplicantMessageTemplate[];
    isTemplateModalOpen = false;

    constructor(
        public route: ActivatedRoute,
        public auth: AuthService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        const [applicantMessageTemplates] = await ApplicantMessageTemplate.all();

        this.applicantMessageTemplates = applicantMessageTemplates;

        this.funnelTemplate = this.route.snapshot.data.models.get('funnelTemplate');
    }

    setPreviousTemplateId(newVal: string | number): void {
        this.previousTemplateId = this.templateId;
        this.templateId = newVal;
    }

    resetTemplateId(): void {
        this.templateId = this.previousTemplateId;
        this.closeTemplateModal();
    }

    verifyOverride(): void {
        if (this.funnelMessageTemplate.body) {
            this.openTemplateModal();
            return;
        }

        this.onTemplateIdChange();
    }

    openTemplateModal(): void {
        this.isTemplateModalOpen = true;
    }

    closeTemplateModal(): void {
        this.isTemplateModalOpen = false;
    }

    onTemplateIdChange(): void {
        const template = this.applicantMessageTemplates.find((t) => t.id === this.templateId);
        this.closeTemplateModal();

        if (!template) {
            this.funnelMessageTemplate.subject = '';
            // Quill does not empty the body correctly with an empty string so we add a space
            this.funnelMessageTemplate.body = ' ';
            return;
        }

        this.funnelMessageTemplate.subject = template.subject;
        this.funnelMessageTemplate.body = template.body;
    }
}
